import { invariant } from '@streem/toolbox';
export function getVideoMetricsForRemoteUser(observableVideoMetrics, localAttendeeId, logger) {
    const remoteAttendeeIds = Object.keys(observableVideoMetrics).filter(id => id !== localAttendeeId);
    if (remoteAttendeeIds.length > 1) {
        logger.warn(`getVideoMetricsForRemoteUser(): expected at most 1 remote user id, but got ${remoteAttendeeIds.length}.  UserIds: ${remoteAttendeeIds}`);
        return undefined;
    }
    else if (remoteAttendeeIds.length === 0) {
        return undefined;
    }
    const remoteUserId = remoteAttendeeIds[0];
    const streemsForRemoteUser = Object.keys(observableVideoMetrics[remoteUserId]);
    invariant(streemsForRemoteUser.length > 0, 'expected at least 1 streem for remote user');
    const streamId = streemsForRemoteUser[0];
    return observableVideoMetrics[remoteUserId][streamId];
}
//# sourceMappingURL=get_video_metrics_for_remote_user.js.map